import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';

import { routes } from './app.routes';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
  HttpClient,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import {
  FraudTheme,
  API_URL,
  HUB_URL,
  REPORT_URL,
  JwtInterceptor,
  APP_NAME,
  SHOW_ETHNIKI_LOGO,
  TranslationLoader,
  LoggingInterceptor,
  GlobalErrorHandlerService,
  AppConfigService,
} from 'shared-library';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    // provideHttpClient(withFetch()),
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      })
    ),
    provideAnimationsAsync(),
    provideTranslateService({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslationLoader(http),
        deps: [HttpClient],
      },
    }),
    providePrimeNG({
      translation: { dateFormat: 'dd/mm/yy' },
      theme: {
        preset: FraudTheme,
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
    MessageService,
    // { provide: API_URL, useValue: '/api/' },
    { provide: API_URL, useValue: environment.api },
    { provide: HUB_URL, useValue: environment.hub },
    { provide: REPORT_URL, useValue: environment.reportUrl },
    { provide: APP_NAME, useValue: 'coreact' },
    { provide: SHOW_ETHNIKI_LOGO, useValue: environment.showEthnikiLogo ?? false },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
    // { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    // provideAppInitializer(() => inject(AppConfigService).loadConfig()),
  ],
};
